import apiClient from './client';

// ─── Versandprotokoll ────────────────────────────────────────────────────────

/**
 * Muss zur Liste im Backend passen (`MailAnlass` in `email.service.ts`).
 *
 * Fehlt hier ein Anlass, den das Backend verschickt, steht er im Protokoll
 * ohne Beschriftung und lässt sich nicht filtern – genau das war bei
 * `betriebszugriff` eine Weile der Fall.
 */
export type MailAnlass =
  | 'einladung'
  | 'betriebszugriff'
  | 'zweiter-faktor'
  | 'passwort'
  | 'anmeldung'
  | 'rundnachricht'
  | 'kalender'
  | 'probe'
  | 'smtp-test'
  | 'sonstige';

export interface VersandEintrag {
  id: string;
  empfaenger: string;
  betreff: string;
  anlass: MailAnlass;
  erfolg: boolean;
  fehler: string | null;
  bezug: string | null;
  zeitpunkt: string;
}

export interface VersandprotokollAntwort {
  eintraege: VersandEintrag[];
  gesamt: number;
  /** Wie viele davon fehlgeschlagen sind – die Zahl, nach der man sucht. */
  fehlerZahl: number;
  seite: number;
  proSeite: number;
}

export interface VersandFilter {
  empfaenger?: string;
  anlass?: string;
  nurFehler?: boolean;
  seite?: number;
}

export async function fetchVersandprotokoll(
  filter: VersandFilter = {},
): Promise<VersandprotokollAntwort> {
  const { data } = await apiClient.get<VersandprotokollAntwort>('/versandprotokoll', {
    params: {
      ...(filter.empfaenger ? { empfaenger: filter.empfaenger } : {}),
      ...(filter.anlass ? { anlass: filter.anlass } : {}),
      ...(filter.nurFehler ? { nurFehler: '1' } : {}),
      ...(filter.seite ? { seite: filter.seite } : {}),
    },
  });
  return data;
}
